import React from "react";

const IconLike = props => (
  <svg viewBox="0 0 24 24" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h24v24H0z" />
      <path
        d="M8 19h6c3.407 0 6-2.576 6-6v-3h-6V5h-1.434l-3 5H8v9zm-2 0v-9H4v9h2zM8.434 8l3-5H16v5h4a2 2 0 0 1 2 2v3c0 4.531-3.491 8-8 8H2V8h6.434z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </g>
  </svg>
);

export default IconLike;
